export default __webpack_public_path__ + "static/media/Logo.5dfcb71a.svg";